import { CommonModule } from '@angular/common';
import { Component, Inject, inject, signal } from '@angular/core';
import {
  NgbDropdown,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle
} from '@ng-bootstrap/ng-bootstrap';

import { ContactSupportService } from '../../services';
import { HelpEntryService } from '../../../../features/prob/services';
import { UserService } from '../../services';

@Component({
  selector: 'app-help-card', 
  standalone: true,
  imports: [
    CommonModule,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem
  ],
  templateUrl: './help-card.component.html',
  styleUrls: ['./help-card.component.scss']
})
export class HelpCardComponent {

  /** Opens Help in its own tab, resolving context first. */
  private helpEntry = inject(HelpEntryService);

  /** Opens the support form. Shared with the left-hand menu's Contact Support item. */
  private contactSupportService = inject(ContactSupportService);

  /**
 * Whether we are displaying help from external service now or internally
 */
  protected helpExternal = signal<boolean>(true);

  constructor(
    private userService: UserService
    , @Inject('CONFIG_SETTINGS') config: any
  ) {

    this.helpExternal.set(config['general']?.['helpExternal'] === true);
  }

  /**
   * Opens the Contact Support form.
   *
   * The form used to be opened here. It moved to ContactSupportService when the
   * left-hand menu gained its own Contact Support item - two entry points to one form
   * that must behave identically, so there is one copy of how it opens.
   */
  contactSupport() {
    this.contactSupportService.open();
  }

  /**
   * Opens the in-product Help Centre in the Help tab.
   *
   * This used to open userService.helpUrl - the external ServiceNow knowledge base.
   * Help is now content in the application, so it opens the in-product Help Centre
   * instead. userService.helpUrl still exists and is still used by the home page
   * summary; retiring it there is a separate decision.
   *
   * A separate tab rather than routing in place, for the same reason the Help menu uses
   * one: this button sits on every screen including the scenario page, which holds a
   * deal lock and guards unsaved changes. Reading help should not cost the reader their
   * work.
   *
   * The entry service resolves context before opening, so this lands on the article for
   * wherever the reader was rather than the Help home.
   */
  helpCentreLocal() {

    this.helpEntry.open('/help');
  }

  helpCentre() {
    const url = this.userService.helpUrl;
    window.open(url, '_blank');
  }
}
